import Vue from 'vue'

const state = {
  sales: {}
}

const mutations = {
  FETCH (state, sales) {
    state.sales = sales
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('sales')
      .then(response => {
        commit('FETCH', response.data)
      })
  }
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
